var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSignupBackArrow = function SvgSignupBackArrow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.04844 13.0623L7.35469 13.774C7.06094 14.0753 6.58594 14.0753 6.29531 13.774L0.220312 7.545C-0.0734375 7.24365 -0.0734375 6.75636 0.220312 6.45821L6.29531 0.226013C6.58906 -0.0753378 7.06406 -0.0753378 7.35469 0.226013L8.04844 0.937715C8.34531 1.24227 8.33906 1.73918 8.03594 2.03733L4.27031 5.71766H13.2516C13.6672 5.71766 14.0016 6.06068 14.0016 6.48706V7.51294C14.0016 7.93932 13.6672 8.28235 13.2516 8.28235H4.27031L8.03594 11.9627C8.34219 12.2608 8.34844 12.7577 8.04844 13.0623Z",
    fill: "#46548C"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSignupBackArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/signup-back-arrow.7dc30318.svg";
export { ForwardRef as ReactComponent };